import _isEmpty from "lodash/isEmpty";
import React from 'react';
import { getBottomLine, getQualificationsBullets } from '@nerdwallet/marketplace/selectors/small-medium-business-loans';
import { mappings as quickFactMappings } from '@nerdwallet/react-quick-facts';
import Qualifications from '../loans-qualifications';
import { CONTENT_TABS } from '../lib/constants';
export default (function (_ref) {
  var bottomLine = _ref.bottomLine,
      marketplaceEntity = _ref.marketplaceEntity;
  var qualifications = getQualificationsBullets(marketplaceEntity);
  return {
    activeContentTab: CONTENT_TABS.KEY_FACTS,
    bottomLine: null,
    drivers: [quickFactMappings.smbLoans.getQuickFactEstimatedAPR(marketplaceEntity), quickFactMappings.smbLoans.getQuickFactMinCreditScore(marketplaceEntity)],
    keyFacts: bottomLine || getBottomLine(marketplaceEntity),
    productDetails: !_isEmpty(qualifications) ? /*#__PURE__*/React.createElement(Qualifications, {
      bullets: qualifications
    }) : null
  };
});